import React from 'react';
import Box from '@mui/material/Box';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import Typography from '@mui/material/Typography';
import { string } from 'prop-types';

const NoAvailableCard = ({
  type,
  suggestions = 'Try adjusting your search or filter options.',
}) => {
  return (
    <Box
      alignItems="center"
      bgcolor="graphic.lighter"
      borderRadius="4px"
      color="text.secondary"
      display="flex"
      flexDirection="column"
      fontFamily="Overpass"
      fontWeight={300}
      height="100%"
      justifyContent="center"
      padding={3}
      textAlign="center"
      width="100%"
    >
      <BlockRoundedIcon
        sx={{
          color: '_next.text.primary',
          fill: '_next.text.primary',
          height: 24,
          mb: 1,
          width: 24,
        }}
      />
      <Typography
        sx={{
          color: '_next.text.primary',
          textAlign: 'center',
        }}
        variant="h6"
      >
        No available {type ?? 'data'}
      </Typography>
      <Typography sx={{ color: '_next.text.primary', textAlign: 'center' }} variant="body1">
        {suggestions}
      </Typography>
    </Box>
  );
};

NoAvailableCard.propTypes = {
  suggestions: string.isRequired,
  type: string.isRequired,
};

export default NoAvailableCard;
